import React from 'react';
import PropTypes from 'prop-types';
// import { format as dateFormat } from 'date-fns';
import Link from 'components/Link';
// import { ZEB_PAY_URL } from '../../../../../constants';
import s from './Byline.scss';

function getSeparator(length, index) {
  let separater = '';
  if (length > 1 && index !== length) {
    separater = length - index !== 1 ? ', ' : ' & ';
  }

  return separater;
}
class Byline extends React.PureComponent {
  getArticleshpwDate() {
    let dateStr = '';
    let updatedText = '';
    if (this.props.dl && this.props.upd) {
      const updatedNum = parseInt(this.props.upd, 10);
      const createdNum = parseInt(this.props.dl, 10);
      if (updatedNum - createdNum > 60000) {
        dateStr = this.props.updStr;
        updatedText = 'Updated:';
      } else {
        dateStr = this.props.dlStr;
      }

      dateStr = `${updatedText} ${dateStr}`;
      if (this.props.removeTime && dateStr.includes('IST')) {
        const temp = dateStr.split(',');
        temp.pop();
        dateStr = temp.join(', ');
      }
    }

    return dateStr;
  }

  getAuthorHtml() {
    let returnHtml;
    if (this.props.author && this.props.author.length) {
      const { author } = this.props;
      const len = author.length;
      if (this.props.toipLayout) {
        returnHtml = author.map((val, index) => {
          const authorUrl = `/toi-plus/author-${val.name
            ?.replace(/ /g, '')
            .toLowerCase()}-${val.id}`;
          return (
            <React.Fragment key={index}>
              <Link to={authorUrl}>{val.name}</Link>

              {getSeparator(len, index + 1)}
            </React.Fragment>
          );
        });
      } else {
        returnHtml = author.map((val, index) => (
          <React.Fragment key={index}>
            {!val.wu ? (
              `${val.name}${getSeparator(len, index + 1)}`
            ) : (
              <>
                <Link target="_blank" to={val.wu}>
                  {val.name}
                </Link>

                {getSeparator(len, index + 1)}
              </>
            )}
          </React.Fragment>
        ));
      }
    }

    return returnHtml;
  }

  render() {
    const authorHtml = this.getAuthorHtml();
    const {
      isWapView,
      toipLayout,
      ag,
      guestName,
      categoryLink,
      newStoryPage,
    } = this.props;
    if (toipLayout) {
      return (
        <div
          className={`${s.authors} ${this.props.sClassName} ${
            s.primeshowContainer
          } ${newStoryPage ? s.storyblockernewWrapper : ''}`}
        >
          {authorHtml ? (
            <span className={s.primeAuthorSection}>{authorHtml}</span>
          ) : null}
          {ag ? (
            <span className={`${s.agency} ${s.primeAuthorSection}`}>{ag}</span>
          ) : (
            ''
          )}
          {!ag && guestName ? (
            <span className={`${s.agency} ${s.primeAuthorSection}`}>{ag}</span>
          ) : (
            ''
          )}
          {/* {!isWapView &&
            tag && (
              <span className={s.tag}>
                <img
                  className={s.trendIcon}
                  src="https://static.toiimg.com/photo/89633497.cms"
                  alt="Trending"
                  width="16"
                  height="8"
                />
                #{tag}
              </span>
            )} */}
          {isWapView && (
            <div className={`${s.primeshowContainer} ${s.primeDateSection}`}>
              <span className={`${toipLayout ? s.date : ''}`}>
                {this.getArticleshpwDate()}
              </span>
              {/* {tag && (
                <span className={s.tag}>
                  <img
                    className={s.trendIcon}
                    src="https://static.toiimg.com/photo/89633497.cms"
                    alt="Trending"
                    width="16"
                    height="8"
                  />
                  #{tag}
                </span>
              )} */}
            </div>
          )}
        </div>
      );
    }

    let categoryText;
    if (this.props.category && categoryLink && categoryLink !== '') {
      categoryText = (
        <Link className={s.country} to={this.props.categoryLink}>
          {this.props.category}
        </Link>
      );
    } else if (this.props.category) {
      categoryText = <span className={s.country}>{this.props.category} </span>;
    }

    if (this.props.category) {
      return (
        <div className={`${s.authors} ${this.props.sClassName}`}>
          {this.props.showCategory && this.props.category ? categoryText : ''}
          {this.props.category ? ` / ` : ''}
          {authorHtml}
          {`${authorHtml ? ` / ` : ''}`}
          {this.props.ag ? `${this.props.ag} / ` : ''}
          {this.props.guestName ? `${this.props.guestName} / ` : ''}

          <span>
            {this.getArticleshpwDate() ? `${this.getArticleshpwDate()}` : ''}
          </span>
        </div>
      );
    }
    return (
      <div className={`${s.authors} ${this.props.sClassName}`}>
        {authorHtml}
        {`${authorHtml ? ` / ` : ''}${
          this.props.ag ? `${this.props.ag} / ` : ''
        }${this.props.guestName ? `${this.props.guestName} / ` : ''}`}
        <span>{this.getArticleshpwDate()}</span>
      </div>
    );
  }
}

Byline.propTypes = {
  guestName: PropTypes.string,
  author: PropTypes.arrayOf(PropTypes.shape({})),
  ag: PropTypes.string,
  upd: PropTypes.string.isRequired,
  dl: PropTypes.string.isRequired,
  isWapView: PropTypes.bool,
  sClassName: PropTypes.string.isRequired,
  dlStr: PropTypes.string,
  updStr: PropTypes.string,
  navSubsection: PropTypes.shape({}),
  showCategory: PropTypes.bool,
  category: PropTypes.string,
  categoryLink: PropTypes.string,
  toipLayout: PropTypes.bool,
  removeTime: PropTypes.bool,
};

Byline.defaultProps = {
  author: [],
  ag: '',
  guestName: '',
  isWapView: false,
  navSubsection: '',
  dlStr: '',
  updStr: '',
  showCategory: false,
  category: '',
  categoryLink: '',
  toipLayout: false,
  removeTime: false,
};

export default Byline;
